/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ModelBoolean,
  ModelBooleanOptional,
  ModelBooleanMetaI,
  ModelBooleanTrackedI,
} from "./model-boolean";
import { ModelBooleanTracked, ModelBooleanMeta } from "./model-boolean";

/**
 *
 * @export
 * @interface APEligibleClass
 */
export interface APEligibleClassOptional {
  /**
   *
   * @type {number}
   * @memberof APEligibleClass
   */
  instanceId?: number;
  /**
   *
   * @type {string}
   * @memberof APEligibleClass
   */
  typeName?: string;
  /**
   *
   * @type {number}
   * @memberof APEligibleClass
   */
  sessionCount?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof APEligibleClass
   */
  sessionDates?: Date[];
  /**
   *
   * @type {boolean}
   * @memberof APEligibleClass
   */
  signupsAvailable?: boolean;
  /**
   *
   * @type {string}
   * @memberof APEligibleClass
   */
  nextSignupsOpen?: Date;
  /**
   *
   * @type {number}
   * @memberof APEligibleClass
   */
  nextSignupsCount?: number;
  /**
   *
   * @type {string}
   * @memberof APEligibleClass
   */
  instructor?: string;
  /**
   *
   * @type {string}
   * @memberof APEligibleClass
   */
  location?: string;
  /**
   *
   * @type {ModelBoolean}
   * @memberof APEligibleClass
   */
  booleanEnumTest?: ModelBoolean;
}

export interface APEligibleClass extends APEligibleClassOptional {
  /**
   *
   * @type {number}
   * @memberof APEligibleClass
   */
  instanceId?: number;
  /**
   *
   * @type {string}
   * @memberof APEligibleClass
   */
  typeName?: string;
  /**
   *
   * @type {number}
   * @memberof APEligibleClass
   */
  sessionCount?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof APEligibleClass
   */
  sessionDates?: Date[];
  /**
   *
   * @type {boolean}
   * @memberof APEligibleClass
   */
  signupsAvailable?: boolean;
  /**
   *
   * @type {string}
   * @memberof APEligibleClass
   */
  nextSignupsOpen?: Date;
  /**
   *
   * @type {number}
   * @memberof APEligibleClass
   */
  nextSignupsCount?: number;
  /**
   *
   * @type {string}
   * @memberof APEligibleClass
   */
  instructor?: string;
  /**
   *
   * @type {string}
   * @memberof APEligibleClass
   */
  location?: string;
  /**
   *
   * @type {ModelBoolean}
   * @memberof APEligibleClass
   */
  booleanEnumTest?: ModelBoolean;
}

export interface APEligibleClassTrackedI {
  /**
   *
   * @type {number}
   * @memberof APEligibleClass
   */
  instanceId?: number;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof APEligibleClass
   */
  typeName?: string;
  typeNameIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof APEligibleClass
   */
  sessionCount?: number;
  sessionCountIsSet: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof APEligibleClass
   */
  sessionDates?: Date[];
  sessionDatesIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof APEligibleClass
   */
  signupsAvailable?: boolean;
  signupsAvailableIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof APEligibleClass
   */
  nextSignupsOpen?: Date;
  nextSignupsOpenIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof APEligibleClass
   */
  nextSignupsCount?: number;
  nextSignupsCountIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof APEligibleClass
   */
  instructor?: string;
  instructorIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof APEligibleClass
   */
  location?: string;
  locationIsSet: boolean;
  /**
   *
   * @type {ModelBoolean}
   * @memberof APEligibleClass
   */
  booleanEnumTest?: ModelBoolean;
  booleanEnumTestIsSet: boolean;
}

transformDatesMap.set("APEligibleClass", function (model: APEligibleClass) {
  if (Array.isArray(model.sessionDates))
    model.sessionDates = model.sessionDates.map((a) => new Date(a));
  if (typeof model.nextSignupsOpen == "string")
    model.nextSignupsOpen = new Date(model.nextSignupsOpen);
});

export type APEligibleClassMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  typeName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sessionCount: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  sessionDates: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  signupsAvailable: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: true
  nextSignupsOpen: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  nextSignupsCount: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  instructor: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  location: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  booleanEnumTest: PropertyMeta<ModelBooleanMetaI>;
}>;

export var APEligibleClassMeta: APEligibleClassMetaI =
  {} as APEligibleClassMetaI;
APEligibleClassMeta = typeMeta("APEligibleClass", {
  instanceId: propertyMeta(
    "instanceId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  typeName: propertyMeta("typeName", false, false, false, MetaTypesBase.string),
  sessionCount: propertyMeta(
    "sessionCount",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  sessionDates: propertyMeta(
    "sessionDates",
    true,
    false,
    false,
    MetaTypesBase.string,
  ),
  signupsAvailable: propertyMeta(
    "signupsAvailable",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  nextSignupsOpen: propertyMeta(
    "nextSignupsOpen",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  nextSignupsCount: propertyMeta(
    "nextSignupsCount",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  instructor: propertyMeta(
    "instructor",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  location: propertyMeta("location", false, false, false, MetaTypesBase.string),
  booleanEnumTest: propertyMeta(
    "booleanEnumTest",
    false,
    false,
    false,
    ModelBooleanMeta,
  ),
});

const metaI = APEligibleClassMeta;

registerMeta(() => {});

export class APEligibleClassTracked implements APEligibleClassTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  instanceId__I?: number = undefined;
  instanceIdIsSet: boolean = false;
  set instanceId(v: undefined | number) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  typeName__I?: string = undefined;
  typeNameIsSet: boolean = false;
  set typeName(v: undefined | string) {
    if (v !== undefined) {
      this.typeName__I = v;
      this.typeNameIsSet = true;
    } else {
      this.typeName__I = v || undefined;
      this.typeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeName() {
    return this.typeName__I;
  }
  sessionCount__I?: number = undefined;
  sessionCountIsSet: boolean = false;
  set sessionCount(v: undefined | number) {
    if (v !== undefined) {
      this.sessionCount__I = v;
      this.sessionCountIsSet = true;
    } else {
      this.sessionCount__I = v || undefined;
      this.sessionCountIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionCount() {
    return this.sessionCount__I;
  }
  sessionDates__I?: Date[] = undefined;
  sessionDatesIsSet: boolean = false;
  set sessionDates(v: undefined | Date[]) {
    if (v !== undefined) {
      this.sessionDates__I = v;
      this.sessionDatesIsSet = true;
    } else {
      this.sessionDates__I = v || undefined;
      this.sessionDatesIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionDates() {
    return this.sessionDates__I;
  }
  signupsAvailable__I?: boolean = undefined;
  signupsAvailableIsSet: boolean = false;
  set signupsAvailable(v: undefined | boolean) {
    if (v !== undefined) {
      this.signupsAvailable__I = v;
      this.signupsAvailableIsSet = true;
    } else {
      this.signupsAvailable__I = v || undefined;
      this.signupsAvailableIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupsAvailable() {
    return this.signupsAvailable__I;
  }
  nextSignupsOpen__I?: Date = undefined;
  nextSignupsOpenIsSet: boolean = false;
  set nextSignupsOpen(v: undefined | Date) {
    if (v !== undefined) {
      this.nextSignupsOpen__I = v;
      this.nextSignupsOpenIsSet = true;
    } else {
      this.nextSignupsOpen__I = v || undefined;
      this.nextSignupsOpenIsSet = false;
    }
    this.changeTracker = true;
  }
  get nextSignupsOpen() {
    return this.nextSignupsOpen__I;
  }
  nextSignupsCount__I?: number = undefined;
  nextSignupsCountIsSet: boolean = false;
  set nextSignupsCount(v: undefined | number) {
    if (v !== undefined) {
      this.nextSignupsCount__I = v;
      this.nextSignupsCountIsSet = true;
    } else {
      this.nextSignupsCount__I = v || undefined;
      this.nextSignupsCountIsSet = false;
    }
    this.changeTracker = true;
  }
  get nextSignupsCount() {
    return this.nextSignupsCount__I;
  }
  instructor__I?: string = undefined;
  instructorIsSet: boolean = false;
  set instructor(v: undefined | string) {
    if (v !== undefined) {
      this.instructor__I = v;
      this.instructorIsSet = true;
    } else {
      this.instructor__I = v || undefined;
      this.instructorIsSet = false;
    }
    this.changeTracker = true;
  }
  get instructor() {
    return this.instructor__I;
  }
  location__I?: string = undefined;
  locationIsSet: boolean = false;
  set location(v: undefined | string) {
    if (v !== undefined) {
      this.location__I = v;
      this.locationIsSet = true;
    } else {
      this.location__I = v || undefined;
      this.locationIsSet = false;
    }
    this.changeTracker = true;
  }
  get location() {
    return this.location__I;
  }
  booleanEnumTest__I?: ModelBoolean = undefined;
  booleanEnumTestIsSet: boolean = false;
  set booleanEnumTest(v: undefined | ModelBoolean) {
    if (v !== undefined) {
      this.booleanEnumTest__I = v;
      this.booleanEnumTestIsSet = true;
    } else {
      this.booleanEnumTest__I = v || undefined;
      this.booleanEnumTestIsSet = false;
    }
    this.changeTracker = true;
  }
  get booleanEnumTest() {
    return this.booleanEnumTest__I;
  }
  constructor(config?: APEligibleClassOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: APEligibleClassOptional,
    options?: AssignOptions,
  ): APEligibleClassTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = config.instanceId;
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (config.typeName && this.typeNameApplyFilter(optionsRequired.filter)) {
      this.typeName = config.typeName;
      if (optionsRequired.unassign) this.typeNameIsSet = false;
      else this.typeNameIsSet = true;
    }
    if (
      config.sessionCount &&
      this.sessionCountApplyFilter(optionsRequired.filter)
    ) {
      this.sessionCount = config.sessionCount;
      if (optionsRequired.unassign) this.sessionCountIsSet = false;
      else this.sessionCountIsSet = true;
    }
    if (
      config.sessionDates &&
      this.sessionDatesApplyFilter(optionsRequired.filter)
    ) {
      this.sessionDates = config.sessionDates;
      if (optionsRequired.unassign) this.sessionDatesIsSet = false;
      else this.sessionDatesIsSet = true;
    }
    if (
      config.signupsAvailable &&
      this.signupsAvailableApplyFilter(optionsRequired.filter)
    ) {
      this.signupsAvailable = config.signupsAvailable;
      if (optionsRequired.unassign) this.signupsAvailableIsSet = false;
      else this.signupsAvailableIsSet = true;
    }
    if (
      config.nextSignupsOpen &&
      this.nextSignupsOpenApplyFilter(optionsRequired.filter)
    ) {
      this.nextSignupsOpen = config.nextSignupsOpen;
      if (optionsRequired.unassign) this.nextSignupsOpenIsSet = false;
      else this.nextSignupsOpenIsSet = true;
    }
    if (
      config.nextSignupsCount &&
      this.nextSignupsCountApplyFilter(optionsRequired.filter)
    ) {
      this.nextSignupsCount = config.nextSignupsCount;
      if (optionsRequired.unassign) this.nextSignupsCountIsSet = false;
      else this.nextSignupsCountIsSet = true;
    }
    if (
      config.instructor &&
      this.instructorApplyFilter(optionsRequired.filter)
    ) {
      this.instructor = config.instructor;
      if (optionsRequired.unassign) this.instructorIsSet = false;
      else this.instructorIsSet = true;
    }
    if (config.location && this.locationApplyFilter(optionsRequired.filter)) {
      this.location = config.location;
      if (optionsRequired.unassign) this.locationIsSet = false;
      else this.locationIsSet = true;
    }
    if (
      config.booleanEnumTest &&
      this.booleanEnumTestApplyFilter(optionsRequired.filter)
    ) {
      this.booleanEnumTest = config.booleanEnumTest;
      if (optionsRequired.unassign) this.booleanEnumTestIsSet = false;
      else this.booleanEnumTestIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): APEligibleClassTrackedI {
    const cloned = {} as APEligibleClassTrackedI;
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId;
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.typeNameIsSetDeep() &&
      this.typeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeNameIsSet = true;
      cloned.typeName = this.typeName;
    } else {
      //cloned.typeNameIsSet = false
    }
    if (
      this.sessionCountIsSetDeep() &&
      this.sessionCountApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionCountIsSet = true;
      cloned.sessionCount = this.sessionCount;
    } else {
      //cloned.sessionCountIsSet = false
    }
    if (
      this.sessionDatesIsSetDeep() &&
      this.sessionDatesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionDatesIsSet = true;
      cloned.sessionDates = this.sessionDates;
    } else {
      //cloned.sessionDatesIsSet = false
    }
    if (
      this.signupsAvailableIsSetDeep() &&
      this.signupsAvailableApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupsAvailableIsSet = true;
      cloned.signupsAvailable = this.signupsAvailable;
    } else {
      //cloned.signupsAvailableIsSet = false
    }
    if (
      this.nextSignupsOpenIsSetDeep() &&
      this.nextSignupsOpenApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.nextSignupsOpenIsSet = true;
      cloned.nextSignupsOpen = this.nextSignupsOpen;
    } else {
      //cloned.nextSignupsOpenIsSet = false
    }
    if (
      this.nextSignupsCountIsSetDeep() &&
      this.nextSignupsCountApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.nextSignupsCountIsSet = true;
      cloned.nextSignupsCount = this.nextSignupsCount;
    } else {
      //cloned.nextSignupsCountIsSet = false
    }
    if (
      this.instructorIsSetDeep() &&
      this.instructorApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instructorIsSet = true;
      cloned.instructor = this.instructor;
    } else {
      //cloned.instructorIsSet = false
    }
    if (
      this.locationIsSetDeep() &&
      this.locationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.locationIsSet = true;
      cloned.location = this.location;
    } else {
      //cloned.locationIsSet = false
    }
    if (
      this.booleanEnumTestIsSetDeep() &&
      this.booleanEnumTestApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.booleanEnumTestIsSet = true;
      cloned.booleanEnumTest = this.booleanEnumTest;
    } else {
      //cloned.booleanEnumTestIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): APEligibleClassTrackedI {
    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;

    if (!this.typeNameApplyFilter(filter)) this.typeNameIsSet = false;

    if (!this.sessionCountApplyFilter(filter)) this.sessionCountIsSet = false;

    if (!this.sessionDatesApplyFilter(filter)) this.sessionDatesIsSet = false;

    if (!this.signupsAvailableApplyFilter(filter))
      this.signupsAvailableIsSet = false;

    if (!this.nextSignupsOpenApplyFilter(filter))
      this.nextSignupsOpenIsSet = false;

    if (!this.nextSignupsCountApplyFilter(filter))
      this.nextSignupsCountIsSet = false;

    if (!this.instructorApplyFilter(filter)) this.instructorIsSet = false;

    if (!this.locationApplyFilter(filter)) this.locationIsSet = false;

    if (!this.booleanEnumTestApplyFilter(filter))
      this.booleanEnumTestIsSet = false;

    return this;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APEligibleClassMeta.instanceId,
      APEligibleClassMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;

    return false;
  }
  typeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APEligibleClassMeta.typeName,
      APEligibleClassMeta,
      this.typeName,
      this,
    );
  }
  typeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeNameIsSet && this.typeNameApplyFilter(filter)) return true;

    return false;
  }
  sessionCountApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APEligibleClassMeta.sessionCount,
      APEligibleClassMeta,
      this.sessionCount,
      this,
    );
  }
  sessionCountIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionCountIsSet && this.sessionCountApplyFilter(filter))
      return true;

    return false;
  }
  sessionDatesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APEligibleClassMeta.sessionDates,
      APEligibleClassMeta,
      this.sessionDates,
      this,
    );
  }
  sessionDatesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionDatesIsSet && this.sessionDatesApplyFilter(filter))
      return true;

    return false;
  }
  signupsAvailableApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APEligibleClassMeta.signupsAvailable,
      APEligibleClassMeta,
      this.signupsAvailable,
      this,
    );
  }
  signupsAvailableIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupsAvailableIsSet && this.signupsAvailableApplyFilter(filter))
      return true;

    return false;
  }
  nextSignupsOpenApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APEligibleClassMeta.nextSignupsOpen,
      APEligibleClassMeta,
      this.nextSignupsOpen,
      this,
    );
  }
  nextSignupsOpenIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.nextSignupsOpenIsSet && this.nextSignupsOpenApplyFilter(filter))
      return true;

    return false;
  }
  nextSignupsCountApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APEligibleClassMeta.nextSignupsCount,
      APEligibleClassMeta,
      this.nextSignupsCount,
      this,
    );
  }
  nextSignupsCountIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.nextSignupsCountIsSet && this.nextSignupsCountApplyFilter(filter))
      return true;

    return false;
  }
  instructorApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APEligibleClassMeta.instructor,
      APEligibleClassMeta,
      this.instructor,
      this,
    );
  }
  instructorIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instructorIsSet && this.instructorApplyFilter(filter)) return true;

    return false;
  }
  locationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APEligibleClassMeta.location,
      APEligibleClassMeta,
      this.location,
      this,
    );
  }
  locationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.locationIsSet && this.locationApplyFilter(filter)) return true;

    return false;
  }
  booleanEnumTestApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APEligibleClassMeta.booleanEnumTest,
      APEligibleClassMeta,
      this.booleanEnumTest,
      this,
    );
  }
  booleanEnumTestIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.booleanEnumTestIsSet && this.booleanEnumTestApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.typeNameIsSetDeep(filter)) return true;
    if (this.sessionCountIsSetDeep(filter)) return true;
    if (this.sessionDatesIsSetDeep(filter)) return true;
    if (this.signupsAvailableIsSetDeep(filter)) return true;
    if (this.nextSignupsOpenIsSetDeep(filter)) return true;
    if (this.nextSignupsCountIsSetDeep(filter)) return true;
    if (this.instructorIsSetDeep(filter)) return true;
    if (this.locationIsSetDeep(filter)) return true;
    if (this.booleanEnumTestIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
